import { render, staticRenderFns } from "./GrowthbookFeatures.vue?vue&type=template&id=a4b02a00&scoped=true"
import script from "./GrowthbookFeatures.vue?vue&type=script&lang=js"
export * from "./GrowthbookFeatures.vue?vue&type=script&lang=js"
import style0 from "./GrowthbookFeatures.vue?vue&type=style&index=0&id=a4b02a00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b02a00",
  null
  
)

export default component.exports